import { Flex, Tooltip } from '@chakra-ui/react';
import { FilterClose } from '@/components/ats/filters/components/UiItems/FilterClose';
import type { FilterProps } from '..';
import { KText } from '@/ui-library/components/text';
export const SelectedFilter = ({
  filter = {},
  onRemoveFilter = () => {},
  onOpenFilter = () => {},
  isReadOnly = false,
  showValuesOnTooltip = false,
  styles = {},
}: {
  filter: any;
  onRemoveFilter?: (_filter: any) => void;
  onReset?: (_filter: any) => void;
  onOpenFilter?: (_filter: any) => void;
  isReadOnly?: boolean;
  showValuesOnTooltip?: boolean;
  styles?: any;
}) => {
  const {
    filter_by,
    filter_condition: condition,
    filter_by_values: values,
  } = filter;
  return (
    <Flex
      bg={isReadOnly ? '#ECE9ED' : 'ats-tertiary'}
      height="fit-content"
      p=".1em .5em"
      borderRadius="2px"
      _hover={{ background: '#F6F7F8' }}
      cursor={!isReadOnly && 'pointer'}
      alignItems="center"
      gap="3px"
      onClick={onOpenFilter}
      flexWrap={isReadOnly ? 'wrap' : 'nowrap'}
      {...styles}
    >
      <KText size="sm-semi-bold">{filter_by?.label}</KText>
      <KText>{condition?.label}</KText>
      {isReadOnly ? (
        values?.map((filter, index) => (
          <KText key={filter.id || index}>
            {index > 0 ? ', ' : ''}
            {filter?.title || filter?.name || filter?.label}
          </KText>
        ))
      ) : showValuesOnTooltip && values?.length > 1 ? (
        <Tooltip
          label={
            <Flex flexDirection="column">
              {values.map((filter, index) => (
                <KText key={index}>
                  {filter?.title || filter?.name || filter?.label}
                </KText>
              ))}
            </Flex>
          }
          bg="white"
          hasArrow
        >
          <Flex alignItems="center">
            <KText>
              {values[0]?.title || values[0]?.name || values[0]?.label}
            </KText>
            {values?.length > 1 && <KText>+ {values.length - 1}</KText>}
          </Flex>
        </Tooltip>
      ) : (
        <>
          <KText>
            {values[0]?.title || values[0]?.name || values[0]?.label}
          </KText>
          {values?.length > 1 && <KText>+ {values.length - 1}</KText>}
        </>
      )}
      {values?.length > 0 && !isReadOnly && !showValuesOnTooltip && (
        <FilterClose onClose={() => onRemoveFilter(filter)} />
      )}
    </Flex>
  );
};

export const SelectedFilters = ({
  selected = [],
  isReadOnly = false,
  onRemoveFilter = () => {},
  onOpenFilter = () => {},
  onReset = () => {},
  disableClearAll = false,
  showValuesOnTooltip = false,
  styles = {},
}: Pick<
  FilterProps,
  | 'selected'
  | 'onRemoveFilter'
  | 'isReadOnly'
  | 'onOpenFilter'
  | 'onReset'
  | 'disableClearAll'
  | 'showValuesOnTooltip'
  | 'styles'
>) => {
  return (
    <Flex gap="4px" alignItems="center" flexWrap="wrap">
      {selected?.map((filter, idx) => {
        if (!filter?.filter_by_values?.length) return null;
        return (
          <SelectedFilter
            key={`selected=${idx}`}
            filter={filter}
            isReadOnly={isReadOnly}
            onRemoveFilter={onRemoveFilter}
            onOpenFilter={onOpenFilter}
            onReset={onReset}
            showValuesOnTooltip={showValuesOnTooltip}
            styles={styles}
          />
        );
      })}
      {selected?.length > 0 && !disableClearAll && !isReadOnly && (
        <KText
          color="primary-600"
          size="sm-semi-bold"
          cursor="pointer"
          _hover={{
            color: 'error-300',
          }}
          onClick={() => {
            onReset();
          }}
        >
          Clear all
        </KText>
      )}
    </Flex>
  );
};
